import Vue from 'vue';
import _ from 'lodash';
import numeral from 'numeral';
import 'numeral/locales/ru';

numeral.locale('ru');
_.assign(numeral.localeData(), {
  currency: {
    symbol: '₽',
  },
});

Vue.prototype.$numeral = numeral;
